import useMutationApi from 'src/api/useMutationApi';

const useDeleteFamousShipment = (
  shipmentId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<Record<string, never>, { message: string }>({
    endpoint: `famous/shipments/${shipmentId}`,
    method: 'DELETE',
    options: {
      onSuccess: onSuccess ? () => onSuccess() : undefined,
    },
    successMessage: 'Shipment deleted successfully',
  });
};

export default useDeleteFamousShipment;
